import CompanySelectFilter from "../../components/filters/CompanyFilter/CompanyFilter";
import { CompanyFilterResult } from "../../components/filters/CompanyFilter/CompanyFilterResult";
import { leadsCapabilityMap } from "../../types/leadsCapability";
import { leadsFilterApiCategory } from "../../types/leadsFilterApiCategory";
import { leadsFilterCategoryMap } from "../../types/leadsFilterCategory";
import { defineLeadsFilter } from "../defineLeadsFilter";

import CompanyFilter from "./CompanyFilter";

// The capability gate (`company-filter`) covers surface availability; the `build` veto covers the data gate
// — the filter only makes sense when the surface actually supplies a company list to pick from.
export const companyDomainsDefinition = defineLeadsFilter({
    key: "companyDomains",
    apiCategory: leadsFilterApiCategory.companyDomains,
    category: leadsFilterCategoryMap.company,
    trackingName: "Company Domains",
    titleKey: { key: "si.lead_gen_filters.group.companyDomains.name" },
    requiresCapabilities: [leadsCapabilityMap.companyFilter],

    render: ({ listCompanies }) =>
        listCompanies && listCompanies.length > 0
            ? {
                  tooltipText: { key: "si.lead_gen_filters.group.includeDomains.tooltip" },
                  filter: new CompanyFilter({ options: listCompanies }),
                  filterView: CompanySelectFilter,
                  filterResultView: CompanyFilterResult,
              }
            : undefined,
});
